import axios from "axios";

function isValidWaxAddress(address, currency, networkType) {
  const waxValidatorURL = "https://wax.pink.gg/v1/chain/get_account";

  return axios
    .post(waxValidatorURL, { account_name: address })
    .then((data) => {
      return data.data.account_name && data.data.account_name.length > 0;
    })
    .catch((error) => {
      if (error?.message === "Network Error") {
        console.error("There is a network error");
      }

      console.error("Invalid WAX address");

      return false;
    });
}

export default {
  isValidAddress(address, currency, networkType) {
    return isValidWaxAddress(address, currency, networkType);
  },
};
